import httpService from "./http.service";
import { store } from "../redux";
import { setInitials } from "../redux/app";

class AppService {
  getInitials = async () => {
    const { data, error } = await httpService.get("/app");
    store.dispatch(setInitials(error ? undefined : data));
    if (data) return data;
  };
  updateFaq = async (data) => {
    return httpService.patch("/app", { items: [{ key: "faq", data }] });
  };
  updateAboutUs = async (data) => {
    return httpService.patch("/app", { items: [{ key: "aboutUs", data }] });
  };
  updateTermCondition = async (data) => {
    return httpService.patch("/app", { items: [{ key: "termCond", data }] });
  };
  updateMetadata = async (model) => {
    return httpService.patch("/app", {
      items: Object.entries(model).map(([key, data]) => ({ key, data })),
    });
  };
}

const appService = new AppService();
export default appService;
